import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/dashboard/dashboard.component').then(m => m.DashboardComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard-home/dashboard-home.component').then(m => m.DashboardHomeComponent)
      },
      {
        path: 'actes-medicaux',
        loadChildren: () => import('./features/medicals-actes/medicals-actes.routes').then(m => m.MEDICALS_ACTES_ROUTES)
      },
      {
        path: 'ipm',
        loadChildren: () => import('./features/ipm/ipm.route').then(m => m.IPM_ROUTES)
      },
      {
        path: 'editeurs',
        loadChildren: () => import('./features/editor/editor.route').then(m => m.EDITOR_ROUTES)
      },
      {
        path: 'structure',
        loadChildren: () => import('./features/structure/structure.route').then(m => m.STRUCTURE_ROUTES)
      },
      {
        path: 'pharmacie',
        loadChildren: () => import('./features/pharmacy/pharmacy.route').then(m => m.PHARMACY_ROUTES)
      },
      {
        path: 'entreprise',
        loadChildren: () => import('./features/entreprise/entreprise.route').then(m => m.ENTREPRISE_ROUTES)
      },
      {
        path: 'produits',
        loadChildren: () => import('./features/products/product.route').then(m => m.PRODUCT_ROUTES)
      },
      {
        path: 'drugs',
        loadChildren: () => import('./features/drugs/drug.route').then(m => m.DRUG_ROUTES)
      },
      {
        path: 'adresse',
        loadChildren: () => import('./features/adresses/address.route').then(m => m.ADDRESS_ROUTES)
      },
      {
        path: 'beneficiary',
        loadChildren: () => import('./features/beneficiary/beneficiary.route').then(m => m.BENEFICIARY_ROUTES)
      },
      {
        path: 'invoice',
        loadChildren: () => import('./features/invoice/invoice.routes').then(m => m.INVOICE_ROUTES)
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        loadChildren: () => import('./features/users/user.routes').then(m => m.USER_ROUTES)
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'controle-medical',
        loadChildren: () => import('./features/alerts/alert.route').then(m => m.MEDICAL_CONTROL_ROUTES)
      },
      {
        path: 'messageries',
        loadChildren: () => import('./features/messageries/messageries.routes').then(m => m.MESSAGERIES_ROUTES)
      },
      {
        path: 'controle-medical-comms',
        loadChildren: () => import('./features/controle-medical/controle-medical.routes').then(m => m.CONTROLE_MEDICAL_ROUTES)
      },
      {
        path: 'diagnostic',
        loadChildren: () => import('./features/diagnostic/diagnostic.routes').then(m => m.DIAGNOSTIC_ROUTES)
      }
    ]
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.route').then(m => m.AUTH_ROUTES)
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
